import { FC } from 'react';

import { AnalyticsEvent, useAnalytics } from '@bonusly/analytics';
import { Stack } from '@bonusly/design-system';
import { useBuildRecognizeURL } from '@bonusly/url';

import { useKeyboardListControl } from '../../hooks/use-keyboard-list-control';
import { UserCard } from '../../modules/top-navbar/components/User';
import { SearchUser } from '../../queries/search';
import { useSearchContext } from './context';
import { SearchResult } from './SearchResult';
import { toUserType } from './utils';

const UserProfileRoute = '/company/users/{id}';

const pathWithId = (path: string, id: string) => path.replace('{id}', id);

export const UsersPanel: FC = () => {
	const { users } = useSearchContext();
	const recognizeURL = useBuildRecognizeURL();

	const { isSelected, register } = useKeyboardListControl<SearchUser, HTMLAnchorElement>({
		emitClickOnSelect: true,
		focusSelected: true,
		onSelectOption: (user) => window.location.assign(recognizeURL(pathWithId(UserProfileRoute, user.objectID))),
		options: users,
		selectOnTab: false,
	});

	const { track } = useAnalytics();

	return (
		<Stack as="ul" listStyleType="none">
			{users?.map((user) => {
				const { onClick, ...props } = register(user);

				return (
					<SearchResult
						aria-label={user.display_name}
						isSelected={isSelected(user)}
						key={user.objectID}
						onClick={() => {
							track(AnalyticsEvent.TopNavbar.UserClick);
							onClick();
						}}
						{...props}
					>
						<UserCard user={toUserType(user)} />
					</SearchResult>
				);
			})}
		</Stack>
	);
};
